/* eslint-disable no-param-reassign */
import { combineReducers } from 'redux';
import { createReducer, createAction } from '@reduxjs/toolkit';

export const filterListByQuery = createAction('@@certificatesList/FILTER_BY_QUERY');
export const clearFilters = createAction('@@certificatesList/CLEAR_FILTERS');

const initialFilter = { query: null };
const filter = createReducer(initialFilter, {
  [clearFilters]() {
    return initialFilter;
  },
  [filterListByQuery](state, { payload }) {
    state.query = payload;
  }
});

const certificatesList = combineReducers({
  filter
});

export const getFilter = (state) => state.certificatesList.filter;

export default certificatesList;
